import { testimonials } from "./testimonials";

/** Texto único de todos os botões que levam ao formulário. Nunca usar "gratuito" ou "sem compromisso". */
export const CTA_LABEL = "Quero um diagnóstico";

export const WHATSAPP_URL =
  "https://api.whatsapp.com/send?phone=5511934001766&text=Vim%20pelo%20site%20da%20Vexly%20e%20tenho%20algumas%20d%C3%BAvidas";

export const WHATSAPP_DISPLAY = "(11) 93400-1766";

export interface NavItem {
  label: string;
  href: string;
}

export const NAV_ITEMS: NavItem[] = [
  { label: "Soluções", href: "#projects" },
  { label: "Como funciona", href: "#process" },
  // "Resultados" só aparece quando houver depoimentos cadastrados
  ...(testimonials.length > 0 ? [{ label: "Resultados", href: "#resultados" }] : []),
  { label: "FAQ", href: "#faq" },
];
